<ng-template [ngIf]="!panel" [ngIfElse]="content">...</ng-template>

<ng-template #content>
  <div class="subject">
    <ng-template [ngIf]="panel.is_favoritable">
      <div class="favorites" (click)="onMakeFavorite($event, panel)">
        <app-icon class="favorites-icon" [class.favorite]="panel.is_favorite" icon="favorites"></app-icon>
      </div>
    </ng-template>

    <a [title]="panel.title | customLocale"
       [routerLink]="link?.path"
       [queryParams]="link?.parameters"
       class="subject-content">

      <div class="cover-wrap">
        <img *ngIf="coverUrl" [src]="coverUrl" [alt]="panel.title" class="cover">
      </div>

      <span class="title bold">{{ panel.title | customLocale }}</span>

      <span class="total normal">{{ getTotalLabel() | customLocale }} {{ panel.total_count }}</span>
    </a>
  </div>
</ng-template>
